/**
 * Eon API
 * The Eon.io REST API
 *
 * AUTOGENERATED: Do not edit the class manually.
 * Instead edit the .mustache file and run `node --run gen-openapi`
 */


export class MsaAcceptanceResponse {
  /**
  * The ID of the eon account this MSA acceptance belongs to
  */
  'eonAccountId': string;
  /**
  * When the MSA was signed
  */
  'signedAt': Date;
  /**
  * The email of the user who signed the MSA
  */
  'signedByEmail': string;

  static readonly discriminator: string | undefined = undefined;

  static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
    {
      "name": "eonAccountId",
      "baseName": "eonAccountId",
      "type": "string",
      "format": ""
    },
    {
      "name": "signedAt",
      "baseName": "signedAt",
      "type": "Date",
      "format": "date-time"
    },
    {
      "name": "signedByEmail",
      "baseName": "signedByEmail",
      "type": "string",
      "format": ""
    }  ];

  static getAttributeTypeMap() {
    return MsaAcceptanceResponse.attributeTypeMap;
  }

  public constructor() {
  }
}

